import * as React from "react";
import { toINR } from "../../../../service/numberFormat";

export interface IHoldMfUsablePopupProps {
	data: any;
	onClose: () => void;
}

const HoldMfUsablePopup: React.FC<IHoldMfUsablePopupProps> = props => {
	return (
		<div className="hold_popup">
			<div>
				<button className="cls" onClick={props.onClose}>
					<i className="edel-icon-close"></i>
				</button>
			</div>
			<div className="content_lr_padding heading_cont btmborder">
				<h2 className="title">{props.data.scName}</h2>
			</div>
			<div className="content_lr_padding">
				<div className="content_tb_padding btmborder bold">
					<div className="row">
						<span>Holding Value</span>
						<span>₹{toINR(props.data.amount)}</span>
					</div>
				</div>
				<div className="content_tb_padding btmborder bold">
					<div className="row">
						<span>Total Quantity</span>
						<span>{toINR(props.data.hdgQty)}</span>
					</div>
					<div className="row">
						<span>Used Quantity</span>
						<span>{toINR(props.data.usdQty)}</span>
					</div>
				</div>
				<div className="content_tb_padding">
					<div className="row">
						<span>NAV</span>
						<span>{toINR(props.data.nav)}</span>
					</div>
					<div className="row">
						<span>Mode</span>
						<span>{toINR(props.data.mode)}</span>
					</div>
					<div className="row">
						<span>Category</span>
						<span>{toINR(props.data.ct)}</span>
					</div>
				</div>
				<div className="btn_cont">
					<button className="btn buy">Buy</button>
					<button className="btn sell">Sell</button>
				</div>
			</div>
		</div>
	);
};

export default HoldMfUsablePopup;
